import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, isSupported } from 'firebase/messaging';
import { fcmConstant } from '../constants/fcm.constant';

export const checkFCMAvailable = () => {
  return new Promise((resolve, reject) => {
    if (!('Notification' in window)) {
      reject('Not supported');
      return;
    }

    isSupported()
      .then(supported => (supported ? resolve(true) : reject(false)))
      .catch(reject);
  });
};

export const setUpFCM = () => {
  initializeApp(fcmConstant);
  const messaging = getMessaging();
  return getToken(messaging, { vapidKey: fcmConstant.vapidKey });
};
